import React from "react";
import { useSortable } from "@dnd-kit/sortable";

function SortableStop({
	stop,
	order,
	total,
	cityPack,
	onRemove,
	onUpdate,
	onMove,
}) {
	const {
		attributes,
		listeners,
		setNodeRef,
		transform,
		transition,
		isDragging,
	} = useSortable({ id: stop.id });

	const style = {
		transform: transform
			? `translate3d(${transform.x}px, ${transform.y}px, 0)`
			: undefined,
		transition,
		opacity: isDragging ? 0.5 : 1,
		zIndex: isDragging ? 10 : 1,
	};

	const place =
		stop.type === "place"
			? cityPack.places.find((p) => p.id === stop.placeId) || null
			: null;

	const customType =
		stop.type === "custom"
			? cityPack.customBlockTypes.find((t) => t.id === stop.customType) || null
			: null;

	const emoji =
		stop.type === "place" ? place?.emoji || "📍" : customType?.emoji || "📝";
	const displayName =
		stop.type === "place"
			? place?.name || stop.placeName || "Lugar"
			: stop.customName || customType?.name || "Bloque";

	const thumb =
		stop.type === "place" ? place?.image : customType?.image || null;

	return (
		<div
			ref={setNodeRef}
			style={style}
			className={`rb-sortable-stop ${isDragging ? "rb-sortable-stop--dragging" : ""}`}
		>
			<button
				className="rb-stop-drag-handle"
				{...attributes}
				{...listeners}
				aria-label="Arrastrar para reordenar"
				title="Arrastra para cambiar el orden"
			>
				<svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
					<circle cx="5" cy="3" r="1.5" />
					<circle cx="11" cy="3" r="1.5" />
					<circle cx="5" cy="8" r="1.5" />
					<circle cx="11" cy="8" r="1.5" />
					<circle cx="5" cy="13" r="1.5" />
					<circle cx="11" cy="13" r="1.5" />
				</svg>
			</button>

			<span className="rb-stop-order" aria-label={`Parada ${order}`}>
				{order}
			</span>

			{thumb ? (
				<img src={thumb} alt="" className="rb-stop-thumb" />
			) : (
				<div className="rb-stop-emoji">{emoji}</div>
			)}

			<div className="rb-stop-content">
				{stop.type === "custom" ? (
					<input
						className="rb-stop-name-input"
						type="text"
						value={stop.customName}
						onChange={(e) => onUpdate(stop.id, { customName: e.target.value })}
						placeholder={
							customType?.id === "custom-place"
								? "Nombre del lugar..."
								: customType?.name || "Nombre..."
						}
					/>
				) : (
					<span className="rb-stop-name">{displayName}</span>
				)}

				<div className="rb-stop-meta-row">
					<input
						className="rb-stop-time-input"
						type="text"
						value={stop.time || ""}
						onChange={(e) => onUpdate(stop.id, { time: e.target.value })}
						placeholder="Hora"
						maxLength={10}
					/>
					<input
						className="rb-stop-note-input"
						type="text"
						value={stop.note || ""}
						onChange={(e) => onUpdate(stop.id, { note: e.target.value })}
						placeholder="Nota breve..."
						maxLength={60}
					/>
				</div>
			</div>

			<div className="rb-stop-move">
				<button
					type="button"
					className="rb-stop-move__btn"
					onClick={() => onMove(stop.id, -1)}
					disabled={order <= 1}
					aria-label="Subir en el orden"
					title="Visitar antes"
				>
					▲
				</button>
				<button
					type="button"
					className="rb-stop-move__btn"
					onClick={() => onMove(stop.id, 1)}
					disabled={order >= total}
					aria-label="Bajar en el orden"
					title="Visitar después"
				>
					▼
				</button>
			</div>

			<button
				className="rb-stop-remove"
				onClick={() => onRemove(stop.id)}
				aria-label="Eliminar parada"
			>
				<svg
					width="18"
					height="18"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				>
					<line x1="18" y1="6" x2="6" y2="18" />
					<line x1="6" y1="6" x2="18" y2="18" />
				</svg>
			</button>
		</div>
	);
}

export default SortableStop;
